package com.trevorwiebe.timesheet

import androidx.compose.ui.ExperimentalComposeUiApi
import androidx.compose.ui.window.ComposeViewport
import com.trevorwiebe.timesheet.core.domain.GeocodingConfig
import com.trevorwiebe.timesheet.di.Debug
import com.trevorwiebe.timesheet.di.configureWebFirestore
import com.trevorwiebe.timesheet.di.jsFirebaseOptions
import com.trevorwiebe.timesheet.di.platformModule
import com.trevorwiebe.timesheet.di.sharedModule
import dev.gitlive.firebase.Firebase
import dev.gitlive.firebase.initialize
import kotlinx.browser.document
import org.koin.core.context.startKoin
import org.koin.dsl.module

@OptIn(ExperimentalComposeUiApi::class)
fun main() {
    Firebase.initialize(options = jsFirebaseOptions)
    if (!Debug.isDebug) {
        configureWebFirestore()
    }
    startKoin {
        modules(
            platformModule,
            sharedModule,
            module { single { GeocodingConfig("") } }
        )
    }
    ComposeViewport(document.body!!) {
        App()
    }
}
